import { Component, h } from '@stencil/core';

@Component({
  tag: 'ci-solutions',
  styleUrl: 'ci-solutions.scss',
})
export class ciSolutions {
  render() {
    const click_section = "solutions";
    return (
      <div class="ciSolutions">
        <section class="ciSolutions-columns">
          <div class="ciSolutions-column ciSolutions-column1">
            <span data-href={`${process.env.CI_HOSTNAME}/ink/group-order-form`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Group Order">
              <span class="ciSolutions-icon">
                <icon-group-ordering></icon-group-ordering>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Group Ordering
                </span>
                <span class="ciSolutions-subtitle">
                  Easily collect sizes, addresses, and payments from your group.
                </span>
              </span>
            </span>
            <a href={`${process.env.CI_HOSTNAME}/fundraising`}
            class="ciSolutions-link js-ciHeader-track"
            data-section={click_section}
            data-link="Fundraising">
              <span class="ciSolutions-icon">
                <icon-fundraising></icon-fundraising>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Fundraising
                </span>
                <span class="ciSolutions-subtitle">
                  Raise money and awareness for anything you care about.
                </span>
              </span>
            </a>
            <span data-href={`${process.env.CI_HOSTNAME}/onlinestores`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Online Stores">
              <span class="ciSolutions-icon">
                <icon-online-stores></icon-online-stores>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Online Stores
                </span>
                <span class="ciSolutions-subtitle">
                  Create a branded storefront to sell merchandise to your community.
                </span>
              </span>
            </span>
          </div>
          <div class="ciSolutions-column ciSolutions-column2">
            <span data-href={`${process.env.CI_HOSTNAME}/inventory-distribution`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Inventory & Distribution">
              <span class="ciSolutions-icon">
                <icon-inventory-distribution></icon-inventory-distribution>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Inventory & Distribution
                </span>
                <span class="ciSolutions-subtitle">
                  Store and send branded swag anywhere. Think of us as your online supply closet!
                </span>
              </span>
            </span>
            <span data-href={`${process.env.CI_HOSTNAME}/swag-boxes`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Swag Boxes">
              <span class="ciSolutions-icon">
                <icon-swag-boxes></icon-swag-boxes>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Swag Boxes
                </span>
                <span class="ciSolutions-subtitle">
                  Create and ship fully custom branded boxes around the world.
                </span>
              </span>
            </span>
          </div>
        </section>
      </div>
    );
  }
}
